import Button from '../../../../../../../ReactSharedScripts/components/Button';
import FlexGrid, { FlexGridColumn } from '../../../../../../../ReactSharedScripts/components/FlexGrid';
import { IconButton } from '../../../../../../../ReactSharedScripts/components/IconButton';
import { AngleDownSmall } from '../../../../../../../ReactSharedScripts/components/Icons/AngleDownSmall';
import { DiscList, ListItem } from '../../../../../../../ReactSharedScripts/components/List';
import { MovingGradient } from '../../../../../../../ReactSharedScripts/components/MovingGradient';
import PaddingBox from '../../../../../../../ReactSharedScripts/components/PaddingBox';
import { TileTitle } from '../../../../../../../ReactSharedScripts/components/Tile';
import Typography from '../../../../../../../ReactSharedScripts/components/Typography';
import { generateListItems } from '../../../../../../../ReactSharedScripts/modules/list/listPage/ListLoadingPlaceholder/utils';
import Spreadsheet, {
	SpreadsheetBody,
	SpreadsheetHead,
	SpreadsheetHeadRow,
} from '../../../../list/components/Spreadsheet';
import { SpreadsheetBodyRowCheckboxLayout } from '../../../../list/components/Spreadsheet/SpreadsheetBodyRowCheckboxLayout';
import { SpreadsheetHeadRowCheckboxLayout } from '../../../../list/components/Spreadsheet/SpreadsheetHeadRowCheckboxLayout';
import { SpreadsheetCardBodyRow } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRow';
import { SpreadsheetCardBodyRowCheckboxSection } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRowCheckboxSection';
import { SpreadsheetCardBodyRowContentCard } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRowContentCard';
import { SpreadsheetCardBodyRowContentSection } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRowContentSection';
import { DocumentCardExtensionIcon } from '../../../components/DocumentCard/DocumentCardExtensionIcon';

const minContentWidth = 120;
const maxContentWidth = 200;
const minTitleWidth = 100;
const maxTitleWidth = 180;

function getRandWidth(min, max) {
	return Math.random() * (max - min) + min;
}

export const DocumentListLoadingPlaceholderListItems = () => {
	const listItems = generateListItems(4);

	return (
		<Spreadsheet minWidth='550px'>
			<SpreadsheetHead>
				<SpreadsheetHeadRow hasCheckbox>
					<SpreadsheetHeadRowCheckboxLayout />
				</SpreadsheetHeadRow>
			</SpreadsheetHead>
			<SpreadsheetBody>
				{listItems.map((item, listItemIndex) => {
					const titleWidth = getRandWidth(minTitleWidth, maxTitleWidth);
					const contentWidth = getRandWidth(minContentWidth, maxContentWidth);

					return (
						<SpreadsheetCardBodyRow key={listItemIndex}>
							<SpreadsheetCardBodyRowCheckboxSection>
								<SpreadsheetBodyRowCheckboxLayout />
							</SpreadsheetCardBodyRowCheckboxSection>
							<SpreadsheetCardBodyRowContentSection>
								<SpreadsheetCardBodyRowContentCard>
									<PaddingBox bottomSmall>
										<FlexGrid gap='small'>
											<FlexGridColumn>
												<DocumentCardExtensionIcon extension='' />
											</FlexGridColumn>
											<FlexGridColumn grow>
												<PaddingBox bottomSmall>
													<FlexGrid spaceBetween>
														<FlexGridColumn grow>
															<TileTitle>
																<MovingGradient
																	height='20px'
																	width={titleWidth}
																/>
															</TileTitle>
															<PaddingBox topScanty>
																<Typography bold>
																	<DiscList inline>
																		<ListItem>
																			<MovingGradient
																				height='16px'
																				width={`${contentWidth}px`}
																			/>
																		</ListItem>
																	</DiscList>
																</Typography>
															</PaddingBox>
														</FlexGridColumn>
														<FlexGridColumn>
															<FlexGrid
																gap='small'
																center
															>
																<FlexGridColumn>
																	<IconButton
																		size='small'
																		rounded
																		link
																	>
																		<AngleDownSmall />
																	</IconButton>
																</FlexGridColumn>
															</FlexGrid>
														</FlexGridColumn>
													</FlexGrid>
												</PaddingBox>
											</FlexGridColumn>
										</FlexGrid>
									</PaddingBox>
									<div
										style={{
											marginTop: '6px',
										}}
									>
										<FlexGrid
											bottom
											spaceBetween
										>
											<FlexGridColumn>
												<FlexGrid gap='small'>
													<FlexGridColumn>
														<MovingGradient
															height='18px'
															width='120px'
														/>
													</FlexGridColumn>
													<FlexGridColumn>
														<MovingGradient
															height='18px'
															width='200px'
														/>
													</FlexGridColumn>
												</FlexGrid>
											</FlexGridColumn>
											<FlexGridColumn>
												<Button
													primary
													disabled
												>
													...
												</Button>
											</FlexGridColumn>
										</FlexGrid>
									</div>
								</SpreadsheetCardBodyRowContentCard>
							</SpreadsheetCardBodyRowContentSection>
						</SpreadsheetCardBodyRow>
					);
				})}
			</SpreadsheetBody>
		</Spreadsheet>
	);
};
